import dayjs from 'dayjs';

export const isExpiredDate: (params: {
  merchantTimeZone: string;
  // YYYY-MM-DD もしくは ISO8601 形式
  baseDate: string;
  // YYYY-MM-DD 形式
  date: string;
}) => boolean = ({ merchantTimeZone, baseDate, date }) => {
  const baseDay = (() => {
    if (baseDate.length === 10) {
      return dayjs.tz(baseDate, 'YYYY-MM-DD', merchantTimeZone).endOf('day');
    } else {
      return dayjs(baseDate).tz(merchantTimeZone).endOf('day');
    }
  })();

  const dateDay = dayjs.tz(date, 'YYYY-MM-DD', merchantTimeZone).endOf('day');

  return dateDay.isBefore(baseDay);
};
